import { render, staticRenderFns } from "./FlexibleBenefits.vue?vue&type=template&id=09b6476c&"
import script from "./FlexibleBenefits.vue?vue&type=script&lang=js&"
export * from "./FlexibleBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports